import styled from 'styled-components';

const SummaryWrapper = styled.div`


`;

export default SummaryWrapper;